module.exports = __webpack_public_path__ + "img/u9030.60c7d29d.svg";